import { actionTypes } from "../Actions/motivoPausa.action";

const initialState = {
  motivoPausas: {
    data: [],
  },
//   vehicle: {},
//   selectedVehicles: {
//     data: [],
//   },
  success: false,
  error: {},
};

export default (state = initialState, { type, payLoad }) => {
  switch (type) {
    case actionTypes.INDEX:
      return {
        ...state,
        motivoPausas: {
          ...state.motivoPausas,
          data: payLoad,
        },
      };
    // case actionTypes.SELECTED:
    //   return {
    //     ...state,
    //     selectedVehicles: {
    //       ...state.selectedVehicles,
    //       data: payLoad,
    //     },
    //   };
    case actionTypes.DESTROY:
      return {
        ...state,
        motivoPausas: {
          ...state.motivoPausas,
          data: state.motivoPausas.data.filter((item) => item.id !== payLoad),
        },
      };
    case actionTypes.CHANGE:
      return {
        ...state,
        vehicle: {
          ...state.vehicle,
          ...payLoad,
        },
      };
    case actionTypes.SUCCESS:
      return { ...state, success: payLoad };
    case actionTypes.ERROR:
      return {
        ...state,
        error: payLoad,
      };
    default:
      return state;
  }
};
